import { Pipe, type PipeTransform } from '@angular/core';
import { getFlagEmoji } from '../functions/get-flag-emoji.function';

@Pipe({ name: 'flagEmoji', standalone: true })
export class FlagEmojiPipe implements PipeTransform {
  transform = getFlagEmoji;
}
